import { Programme } from "../types";
import dateTimeWrapper from "./date-time-wrapper";

class ProgrammeWrapper {
    private _programme: Programme;

    constructor(programme: Programme) {
        this._programme = programme;
    }

    isCurrent(date: string) {
        if (!this._programme) {
            return false;
        }

        const start = dateTimeWrapper(this._programme.startTime);
        const end = dateTimeWrapper(this._programme.endTime);

        const d = dateTimeWrapper(date);
        return start.date === d.date && d.time >= start.time && d.time < end.time;
    }
}

const programmeWrapper = (programme: Programme) => new ProgrammeWrapper(programme);

export default programmeWrapper;